import { CheckCircle2, Phone, Mail, Instagram } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TopBar() {
  const { t } = useTranslation();
  return (
    <div data-testid="topbar" className="bg-[#1C0208] border-b border-[#F5CB5C]/15 text-[11px] sm:text-xs">
      <div className="w-full max-w-7xl 2xl:max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-3 sm:gap-4">
        <div className="flex items-center gap-2 sm:gap-2.5 min-w-0 truncate">
          <span className="hidden md:inline font-display tracking-[0.16em] uppercase text-[#F5CB5C] font-semibold whitespace-nowrap">
            {t("topbar.tagline")}
          </span>
          <span className="hidden md:inline text-white/20">|</span>
          <span className="text-gray-300 truncate">
            {t("topbar.description")}
          </span>
        </div>

        <div className="flex items-center gap-2.5 sm:gap-4 shrink-0 text-gray-300">
          <a
            data-testid="topbar-phone"
            href="tel:+34652463252"
            className="inline-flex items-center gap-1.5 text-gray-200 hover:text-[#F5CB5C] transition-colors font-medium whitespace-nowrap"
          >
            <Phone size={12} className="text-[#F5CB5C]" />
            <span className="tabular-nums font-mono">652 463 252</span>
          </a>
          <span className="hidden sm:inline text-white/20">·</span>
          <a
            data-testid="topbar-email"
            href="mailto:info@laservintage.es"
            className="hidden sm:inline-flex items-center gap-1.5 text-gray-200 hover:text-[#F5CB5C] transition-colors font-medium whitespace-nowrap"
          >
            <Mail size={12} className="text-[#F5CB5C]" />
            <span>info@laservintage.es</span>
          </a>
          <span className="hidden xl:inline text-white/20">·</span>
          <a
            data-testid="topbar-instagram"
            href="https://www.instagram.com/laser__vintage"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden xl:inline-flex items-center gap-1.5 text-gray-200 hover:text-[#F5CB5C] transition-colors font-medium whitespace-nowrap"
          >
            <Instagram size={12} className="text-[#F5CB5C]" />
            <span>@laser__vintage</span>
          </a>
          <span className="hidden md:inline text-white/20">·</span>
          <span data-testid="topbar-guarantee" className="hidden md:inline-flex items-center gap-1.5 text-[#F5CB5C] font-semibold whitespace-nowrap">
            <CheckCircle2 size={13} className="text-emerald-400" /> {t("topbar.guarantee")}
          </span>
        </div>
      </div>
    </div>
  );
}

